import { useIntl } from 'react-intl';
import { Box, Typography } from '@material-ui/core';

// DRAFT: wording to be approved by Małgorzata Gołębiewska with Grant
// Thornton together with the conditions template (change request of 26.10,
// P4). JIT reserves early closing up front, so the consultant always sees
// this line, whatever the issuer wrote in the conditions.
export const EARLY_END_CLAUSE = 'ORDERS.EARLY_END_CLAUSE';

const EarlyEndClause = () => {
  const intl = useIntl();
  return (
    <Box mt={1}>
      <Typography variant="body2" color="textSecondary">
        {intl.formatMessage({ id: EARLY_END_CLAUSE })}
      </Typography>
    </Box>
  );
};

export default EarlyEndClause;
